import { Paginated, Sortable } from "@ac-expo/api-types";

export const commercialMeetingsQueryKeys = {
  all: ["commercial-meetings"] as const,
  byId: (id: string) => [...commercialMeetingsQueryKeys.all, id] as const,
};

export default commercialMeetingsQueryKeys;

export const commercialClientsQueryKeys = {
  all: ["commercial-clients"] as const,
  byEvent: (eventId: string, filters?: Sortable<Paginated>) =>
    [...commercialClientsQueryKeys.all, "lists", eventId, filters] as const,
  byId: (id: string) => [...commercialClientsQueryKeys.all, id] as const,
};

export const commercialQueryKeys = {
  all: ["commercial"] as const,
  byId: (id: string) => [...commercialQueryKeys.all, id] as const,
  mine: () => [...commercialQueryKeys.all, "mine"] as const,
  eventAccess: (eventId: string) =>
    [...commercialQueryKeys.all, "event-access", eventId] as const,
};

export const commercialScanQueryKeys = {
  all: ["commercial", "scan"] as const,
  user: (userId: string) =>
    [...commercialScanQueryKeys.all, "user", userId] as const,
  structure: (structureId: string) =>
    [...commercialScanQueryKeys.all, "structure", structureId] as const,
};
